import _extends from '@babel/runtime/helpers/esm/extends';
import React__default from 'react';
import { TooltipV2 } from '../tooltip-v2/tooltip-v2.js';
import { Icon } from '../icon/icon.js';
import { Close32, Calendar32, DataConnected32, StringText32, StringInteger32 } from '@carbon/icons-react';
import { InputGroup } from '../input-group/input-group.js';
import { IconOnlyButton } from '../icon-only-button/icon-only-button.js';
import { DateInput } from '../datepicker/dateInput.js';
import { NumericInput } from '@blueprintjs/core';

var ConditionalBuilderInputTypeIndicator = function ConditionalBuilderInputTypeIndicator(_ref) {
  var type = _ref.type,
      usingPredeterminedValueIconTooltipText = _ref.usingPredeterminedValueIconTooltipText;

  if (type === "predetermined-value") {
    return /*#__PURE__*/React__default.createElement(TooltipV2, {
      content: usingPredeterminedValueIconTooltipText
    }, /*#__PURE__*/React__default.createElement(Icon, null, /*#__PURE__*/React__default.createElement(DataConnected32, null)));
  }

  if (type === "string") {
    return /*#__PURE__*/React__default.createElement(Icon, null, /*#__PURE__*/React__default.createElement(StringText32, null));
  }

  if (type === "number") {
    return /*#__PURE__*/React__default.createElement(Icon, null, /*#__PURE__*/React__default.createElement(StringInteger32, null));
  }

  return null;
};

var ConditionalBuilderInputValue = function ConditionalBuilderInputValue(_ref2) {
  var _currentCondition$val, _currentCondition$val2;

  var clearPredeterminedValueButtonTooltipText = _ref2.clearPredeterminedValueButtonTooltipText,
      currentCondition = _ref2.currentCondition,
      dispatch = _ref2.dispatch,
      valueInputRef = _ref2.valueInputRef,
      _onClick = _ref2.onClick,
      _onKeyDown = _ref2.onKeyDown,
      ruleId = _ref2.ruleId,
      selectedSourceColumnObj = _ref2.selectedSourceColumnObj,
      stringValuePlaceholderText = _ref2.stringValuePlaceholderText,
      usingPredeterminedValueIconTooltipText = _ref2.usingPredeterminedValueIconTooltipText;

  var clearStringValue = function clearStringValue() {
    return dispatch({
      type: "UPDATE_RULE_VALUE",
      payload: {
        ruleId: ruleId,
        type: "string",
        value: null
      }
    });
  };

  return !currentCondition["type"] || currentCondition["type"] === "string" ? /*#__PURE__*/React__default.createElement(InputGroup, _extends({
    autoComplete: "off",
    fill: true,
    leftIcon: /*#__PURE__*/React__default.createElement(ConditionalBuilderInputTypeIndicator, {
      type: "string",
      usingPredeterminedValueIconTooltipText: usingPredeterminedValueIconTooltipText
    }),
    onChange: function onChange(e) {
      dispatch({
        type: "UPDATE_RULE_VALUE",
        payload: {
          ruleId: ruleId,
          type: "string",
          value: e.target.value
        }
      });
    },
    onClick: function onClick() {
      return _onClick();
    },
    onKeyDown: function onKeyDown(e) {
      return _onKeyDown(e);
    },
    placeholder: stringValuePlaceholderText,
    ref: valueInputRef,
    value: (_currentCondition$val = currentCondition["value"]) !== null && _currentCondition$val !== void 0 ? _currentCondition$val : ""
  }, selectedSourceColumnObj.valueInputProps)) : /*#__PURE__*/React__default.createElement(InputGroup, {
    autoComplete: "off",
    fill: true,
    leftIcon: /*#__PURE__*/React__default.createElement(ConditionalBuilderInputTypeIndicator, {
      type: "predetermined-value",
      usingPredeterminedValueIconTooltipText: usingPredeterminedValueIconTooltipText
    }),
    onClick: function onClick() {
      return _onClick();
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Backspace" || e.key === "Delete") {
        clearStringValue();
      }

      _onKeyDown(e);
    },
    ref: valueInputRef,
    rightElement: /*#__PURE__*/React__default.createElement(IconOnlyButton, {
      icon: Close32,
      minimal: true,
      onClick: function onClick() {
        clearStringValue();
      },
      text: clearPredeterminedValueButtonTooltipText,
      type: "button"
    }),
    value: (_currentCondition$val2 = currentCondition["value"]) !== null && _currentCondition$val2 !== void 0 ? _currentCondition$val2 : ""
  });
};
var ConditionalBuilderNumericValue = function ConditionalBuilderNumericValue(_ref3) {
  var _currentCondition$val3, _currentCondition$val4;

  var clearPredeterminedValueButtonTooltipText = _ref3.clearPredeterminedValueButtonTooltipText,
      currentCondition = _ref3.currentCondition,
      dispatch = _ref3.dispatch,
      valueInputRef = _ref3.valueInputRef,
      _onClick2 = _ref3.onClick,
      _onKeyDown2 = _ref3.onKeyDown,
      ruleId = _ref3.ruleId,
      selectedSourceColumnObj = _ref3.selectedSourceColumnObj,
      usingPredeterminedValueIconTooltipText = _ref3.usingPredeterminedValueIconTooltipText;

  var clearNumericValue = function clearNumericValue() {
    return dispatch({
      type: "UPDATE_RULE_VALUE",
      payload: {
        ruleId: ruleId,
        type: "number",
        value: null
      }
    });
  };

  return !currentCondition["type"] || currentCondition["type"] === "number" ?
  /*#__PURE__*/
  // Wrapper div hack to fix issue with NumericInput component's ref prop.
  React__default.createElement("div", {
    className: "vds-condition-builder-numeric-input-wrapper-ref",
    ref: valueInputRef
  }, /*#__PURE__*/React__default.createElement(NumericInput, _extends({
    fill: true,
    leftIcon: /*#__PURE__*/React__default.createElement(ConditionalBuilderInputTypeIndicator, {
      type: "number",
      usingPredeterminedValueIconTooltipText: usingPredeterminedValueIconTooltipText
    }),
    onClick: function onClick() {
      return _onClick2();
    },
    onKeyDown: function onKeyDown(e) {
      return _onKeyDown2(e);
    },
    onValueChange: function onValueChange(valAsNumber, valueAsString) {
      dispatch({
        type: "UPDATE_RULE_VALUE",
        payload: {
          ruleId: ruleId,
          type: "number",
          value: valueAsString
        }
      });
    },
    placeholder: "0",
    value: (_currentCondition$val3 = currentCondition["value"]) !== null && _currentCondition$val3 !== void 0 ? _currentCondition$val3 : undefined
  }, selectedSourceColumnObj.valueInputProps))) : /*#__PURE__*/React__default.createElement(InputGroup, {
    autoComplete: "off",
    fill: true,
    leftIcon: /*#__PURE__*/React__default.createElement(ConditionalBuilderInputTypeIndicator, {
      type: "predetermined-value",
      usingPredeterminedValueIconTooltipText: usingPredeterminedValueIconTooltipText
    }),
    onClick: function onClick() {
      return _onClick2();
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Backspace" || e.key === "Delete") {
        clearNumericValue();
      }

      _onKeyDown2(e);
    },
    ref: valueInputRef,
    rightElement: /*#__PURE__*/React__default.createElement(IconOnlyButton, {
      icon: Close32,
      minimal: true,
      onClick: function onClick() {
        clearNumericValue();
      },
      text: clearPredeterminedValueButtonTooltipText,
      type: "button"
    }),
    value: (_currentCondition$val4 = currentCondition["value"]) !== null && _currentCondition$val4 !== void 0 ? _currentCondition$val4 : ""
  });
};
var ConditionalBuilderDateValue = function ConditionalBuilderDateValue(_ref4) {
  var _Date, _currentCondition$val5;

  var clearPredeterminedValueButtonTooltipText = _ref4.clearPredeterminedValueButtonTooltipText,
      currentCondition = _ref4.currentCondition,
      dateValuePlaceholderText = _ref4.dateValuePlaceholderText,
      dispatch = _ref4.dispatch,
      valueInputRef = _ref4.valueInputRef,
      _onClick3 = _ref4.onClick,
      _onKeyDown3 = _ref4.onKeyDown,
      ruleId = _ref4.ruleId,
      selectedSourceColumnObj = _ref4.selectedSourceColumnObj,
      usePredeterminedValueButtonTooltipText = _ref4.usePredeterminedValueButtonTooltipText,
      usingPredeterminedValueIconTooltipText = _ref4.usingPredeterminedValueIconTooltipText;

  var clearDateValue = function clearDateValue(options) {
    return dispatch({
      type: "UPDATE_RULE_VALUE",
      payload: {
        ruleId: ruleId,
        type: options.type,
        value: null
      }
    });
  };

  return currentCondition["type"] === "date" ? /*#__PURE__*/React__default.createElement(DateInput, _extends({
    fill: true,
    formatDate: function formatDate(date) {
      return date.toLocaleDateString();
    },
    inputProps: {
      leftIcon: /*#__PURE__*/React__default.createElement(Icon, null, /*#__PURE__*/React__default.createElement(Calendar32, null))
    },
    onChange: function onChange(date) {
      dispatch({
        type: "UPDATE_RULE_VALUE",
        payload: {
          ruleId: ruleId,
          type: "date",
          value: date
        }
      });
    },
    parseDate: function parseDate(str) {
      return new Date(str);
    },
    placeholder: dateValuePlaceholderText,
    popoverProps: {
      position: "bottom",
      minimal: true
    },
    rightElement: selectedSourceColumnObj.selectItems ? /*#__PURE__*/React__default.createElement(IconOnlyButton, {
      icon: DataConnected32,
      minimal: true,
      onClick: function onClick() {
        return clearDateValue({
          type: null
        });
      },
      text: usePredeterminedValueButtonTooltipText,
      type: "button"
    }) : undefined,
    value: (_Date = new Date(currentCondition["value"])) !== null && _Date !== void 0 ? _Date : undefined
  }, selectedSourceColumnObj.valueInputProps)) : /*#__PURE__*/React__default.createElement(InputGroup, {
    autoComplete: "off",
    autoFocus: true,
    fill: true,
    leftIcon: /*#__PURE__*/React__default.createElement(ConditionalBuilderInputTypeIndicator, {
      type: "predetermined-value",
      usingPredeterminedValueIconTooltipText: usingPredeterminedValueIconTooltipText
    }),
    onClick: function onClick() {
      return _onClick3();
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Backspace" || e.key === "Delete") {
        clearDateValue({
          type: "date"
        });
      }

      _onKeyDown3(e);
    },
    ref: valueInputRef,
    rightElement: /*#__PURE__*/React__default.createElement(IconOnlyButton, {
      icon: Close32,
      minimal: true,
      onClick: function onClick() {
        clearDateValue({
          type: "date"
        });
      },
      text: clearPredeterminedValueButtonTooltipText,
      type: "button"
    }),
    value: (_currentCondition$val5 = currentCondition["value"]) !== null && _currentCondition$val5 !== void 0 ? _currentCondition$val5 : ""
  });
};

export { ConditionalBuilderDateValue, ConditionalBuilderInputValue, ConditionalBuilderNumericValue };
//# sourceMappingURL=conditional-builder-value-fields.js.map
